import { useState } from 'react'
import { useIsDesktop } from '@/shared/hooks/useIsDesktop'
import { useLocalStorageBoolean } from '@/shared/hooks/useLocalStorageBoolean'
import { useDocumentCollectionsQuery } from '@/graphql/queries/documentCollectionsQuery.gql.generated'

export function useAppShellState() {
  const [isNavOpen, setIsNavOpen] = useState(false)
  const [isAddCollectionOpen, setIsAddCollectionOpen] = useState(false)
  const isDesktop = useIsDesktop()
  const { value: isNavPinned, setValue: setIsNavPinned } =
    useLocalStorageBoolean({
      key: 'navigation-pinned',
      defaultValue: false,
    })
  const { value: isPinnedMenuExpanded, setValue: setIsPinnedMenuExpanded } =
    useLocalStorageBoolean({
      key: 'navigation-menu-expanded',
      defaultValue: true,
    })
  const { data } = useDocumentCollectionsQuery()
  const collections = data?.documentCollections ?? []

  const showOverlay = !isDesktop || !isNavPinned
  const showPinned = isDesktop && isNavPinned
  const isMainNavigationExpanded = !showPinned || isPinnedMenuExpanded

  function handleMenuClick() {
    if (showOverlay) {
      setIsNavOpen(true)
    }
  }

  function handleTogglePin() {
    if (isNavPinned) {
      setIsNavPinned(false)
    } else {
      setIsNavPinned(true)
      setIsNavOpen(false)
    }
  }

  function handleTogglePinnedMenuExpanded() {
    if (!showPinned) {
      return
    }

    setIsPinnedMenuExpanded((prev) => !prev)
  }

  function handleCreateCollection() {
    if (showOverlay) {
      setIsNavOpen(false)
    }
    setIsAddCollectionOpen(true)
  }

  function handleNavigate() {
    if (showOverlay) {
      setIsNavOpen(false)
    }
  }

  return {
    collections,
    handleCreateCollection,
    handleMenuClick,
    handleNavigate,
    handleTogglePinnedMenuExpanded,
    handleTogglePin,
    isAddCollectionOpen,
    isDesktop,
    isMainNavigationExpanded,
    isNavOpen,
    isNavPinned,
    isPinnedMenuExpanded,
    setIsAddCollectionOpen,
    setIsNavOpen,
    showOverlay,
    showPinned,
  }
}
